import styled from 'styled-components';

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  align-self: stretch;
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  justify-content: space-around;
`;

export const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
